<template>
  <div class="tab">
    <div @click="toPage(item)" v-for="item in tabList" :key="item.id">
      <img :src="item.img" v-if="viewInfo.pageIndex == item.id" />
      <img :src="item.img_d" v-else />
      <div :class="viewInfo.pageIndex == item.id && 'currentItem'">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      tabList: [
        {
          name: '询盘商机',
          path: '/businessAll',
          id: 1,
          img: require('@/assets/images/tab/marketCases2.png'),
          img_d: require('@/assets/images/tab/marketCases1.png'),
        },
        {
          name: '会员中心',
          path: '/vip',
          id: 2,
          img: require('@/assets/images/tab/vipList2.png'),
          img_d: require('@/assets/images/tab/vipList1.png'),
        },
        {
          name: '我的商机',
          path: '/myBusiness',
          id: 3,
          img: require('@/assets/images/tab/myBusiness2.png'),
          img_d: require('@/assets/images/tab/myBusiness1.png'),
        },
        {
          name: '发布商机',
          path: '/addBusiness',
          id: 4,
          img: require('@/assets/images/tab/addBusiness2.png'),
          img_d: require('@/assets/images/tab/addBusiness1.png'),
        },
      ],
    }
  },
  mounted() {},
  methods: {
    toPage(item) {
      this.$router.push({ path: item.path })
    },
  },
  computed: {
    ...mapState(['viewInfo']),
  },
}
</script>
<style lang="scss" scoped>
.tab {
  display: flex;
  width: 100%;
  box-shadow: 0 -3px 5px var(--color_shadow);
  box-sizing: border-box;
  padding: 5px 5px 5px 5px;
  z-index: 10;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    img {
      width: 25px;
      height: 25px;
      margin-bottom: 3px;
    }
    div {
      font-size: 10px;
      color: #707070;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .currentItem {
      color: var(--color_brand);
    }
  }
}
</style>
